import { Alert, Button, Spin } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * Automatic device-registration step (Amendment 02 Part A). There is no
 * "register" button — the device is already identified by the session's captive
 * lease, so the portal registers it immediately after login and shows progress.
 * A recoverable failure (e.g. the captive session expired) is shown with a retry.
 */
export function RegisteringScreen({
  error,
  retrying,
  onRetry,
}: {
  error: string | null;
  retrying: boolean;
  onRetry: () => void;
}) {
  const { t } = useTranslation();
  if (error) {
    return (
      <div className="portal-center">
        <Alert type="error" showIcon message={error} style={{ marginBottom: 16 }} role="alert" />
        <Button type="primary" block loading={retrying} onClick={onRetry}>
          {t('register.retry')}
        </Button>
      </div>
    );
  }
  return (
    <div className="portal-center" style={{ padding: '24px 0' }}>
      <Spin size="large" />
      <p style={{ marginTop: 20 }}>{t('register.working')}</p>
    </div>
  );
}
